// components/Loader.jsx
import React from 'react';
import { useLoader } from '../context/LoaderContext';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="loader" />
        <CircularProgress />
    </div>
  );
};

export default Loader;
